import { GridSortType } from '../../enums';

class GridSortFns {
  constructor(askSortFn, deskSortFn) {
    this[GridSortType.Asc] = GridSortFns.#getWrappedFn(askSortFn);
    this[GridSortType.Desc] = GridSortFns.#getWrappedFn(deskSortFn);
  }

  static #getWrappedFn(fn) {
    return (a, b) => {
      if (!a && !!b) {
        return 1;
      }

      if (!!a && !b) {
        return -1;
      }

      if (!a && !b) {
        return 0;
      }

      return fn(a, b);
    };
  }
}

export default GridSortFns;
